import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Card from './form/Card.js';
import Notification from '../../components/Notification.js'
import General from '../../modules/General.js';
import {setGlobalKey} from '../../actions/General';

class Settings extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			'packages':[],
			'isLoading':true,
			'isWaiting':false,
			'error':false
		}

		this.handleSubmit = this.handleSubmit.bind(this);

	}

	handleSubmit(values) {
        this.props.setGlobalKey('showProcessing',true);
		Stripe.createToken({
            number: values.cardnumber,
            cvc: values.cvc,
            exp_month: values.month,
            exp_year: values.year,
        }, (status, response) => {
            if (response.error) {
                this.props.setGlobalKey('showProcessing',false);

                this.setState({error:response.error.message,'isWaiting':false});
            } else {
            	values.token = response['id'];
            	values.package_id = this.state.package;

                axios.put('/subscriptions/card',values)
                .then(res => {
                    this.props.setGlobalKey('showProcessing',false);
                    Notification.success('Credit card successfully changed');
                	this.props.router.push(General.Link('/settings/billing'));
                	this.setState({error:'','isWaiting':false});
                }).catch(err => {
                    this.props.setGlobalKey('showProcessing',false);
                    this.setState({error:'','isWaiting':false});
                	this.setState({error:err.response.data.error.message});
                })
            }
        });
	}


	componentWillMount() {

	}

	render() {

		return (

				<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-payment"></i> Subscribe</span>
				</div>

				<div className="page-content">

				<Card buttonText="Save card" errorMessage={this.state.error} isWaiting={this.state.isWaiting} onSubmit={this.handleSubmit} />



				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({setGlobalKey},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;



// WEBPACK FOOTER //
// ./containers/settings/BillingCard.js